import React from "react";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";

function GerenciadorFiltros({ filtrosHook }) {
  const { filtros, setFiltros } = filtrosHook;

  return (
    <div className="row">
      <div className="col-md-3">
        <div className="mb-3">
          <CommonInputDate
            label="Período inicial"
            id="inicio"
            value={filtros.inicio}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="mb-3">
          <CommonInputDate
            label="Período final"
            id="fim"
            value={filtros.fim}
            onChange={(e) => handleChange(e, filtros, setFiltros)}
          />
        </div>
      </div>
    </div>
  );
}

GerenciadorFiltros.propTypes = {
  filtrosHook: PropTypes.shape({
    filtros: PropTypes.object.isRequired,
    setFiltros: PropTypes.func.isRequired,
  }).isRequired,
};

export default GerenciadorFiltros;
